import { useNavigate } from 'react-router-dom';
import { Footer } from '../First';

export function UI_UX() {
  const navigate = useNavigate(); // Initialize once

  // Define button details in an array
  const buttons = [
    { label: 'Figma', path: '/Figma' },
    { label: 'Adobe XD / Canva / Sketch', path: '/AdobeXD_Canva_Sketch' },
    { label: 'WireFraming & Prototype', path: '/WireFrame_Prototype' },
    { label: 'AI Tools', path: '/AITools' },
    { label: 'Figma Plugins', path: '/Figma_Plugins' },
    { label: 'Community Groups', path: '/UIX_Community_Group' },
    { label: 'Projects', path: '/Projects' },
  ];

  return (
    <>
      <div className="front_container">
        <div className="front_contain">
          <h2 className="fr_1">UI / UX Designer</h2>
          <p className="fr_2">
            All the resources are available through the links only kindly refer to this. We are
            providing the <br /> recommended platform not for any other promotions.
          </p>
          <p className="fr_rating">4.4 &#9733; &#9733; &#9733; &#9733;</p>
          <p>
            Created by{' '}
            <a
              href="https://www.linkedin.com/in/sayednowshad/"
              style={{
                textDecoration: 'underline',
                fontSize: '17px',
                fontFamily: 'sans-serif',
              }}
            >
              SayedNowshad
            </a>
          </p>
        </div>
      </div>

      <h2 className="fr_des">Description</h2>
      <ul className="fr_list">
        <li className="fr_li">Click the below topics for more concepts to Unlock &#x1F512;</li>
        <li className="fr_li">See the topic-wise and select the topic</li>
        <li className="fr_li">
          Here, we are providing all the facilities for searching and finding the best resources.
          Share this with your friends and spread this out.
        </li>
        <li className="fr_li">
          Thanks & Enjoy <strong>"Stay Hard &#x1F4AA;, Stay Consistently"</strong>
        </li>
      </ul>

      <h3 className="fr_cont">Content</h3>
      <div className="fr_butt">
        {buttons.map(({ label, path }) => (
          <button
            key={path}
            className="fr_butt_click"
            onClick={() => navigate(path)}
          >
            {label}
          </button>
        ))}
      </div>

      <Footer />
    </>
  );
}

export default UI_UX;
